import { WebSocketEntityUpdateInterface } from '@/utils/websocket-entity-updates/webSocketEntityUpdates.types';
import { store } from '@/redux/store';
import { ENTITY_OPERATION_TYPES } from '@/utils/websocket-entity-updates/webSocketEntityUpdates.constants';
import { getModelElement } from '@/redux/modelElements/modelElements.thunks';
import { modelElementDelete, modelElementUpdate } from '@/redux/modelElements/modelElements.slice';

export default async function processElement({
  data,
}: {
  data: WebSocketEntityUpdateInterface;
}): Promise<void> {
  const { dispatch } = store;
  if (
    data.type === ENTITY_OPERATION_TYPES.ENTITY_CREATED ||
    data.type === ENTITY_OPERATION_TYPES.ENTITY_UPDATED
  ) {
    const element = await dispatch(
      getModelElement({ modelId: data.mapId, elementId: data.entityId }),
    ).unwrap();
    if (!element) {
      return;
    }
    dispatch(modelElementUpdate({ modelId: data.mapId, element }));
  } else if (data.type === ENTITY_OPERATION_TYPES.ENTITY_DELETED) {
    dispatch(modelElementDelete({ modelId: data.mapId, elementId: data.entityId }));
  }
}
